
import { AddPrimitivesCommand, BasicControl, DYMODE_MODE, ExtrudeSurfaceT, Listeners, MOUSE, Plane, PlineT, Point, StraightLine, TnEngineContext, TnEngineExtraContext, ViewEditor, dymode, vector3AngleTo } from 'pytha';
import { Vector3 } from "three";
import { ARCHI_CTRL_TYPE } from '../enums/archibase-control-type';
import { getSpecialPrimitiveLayerUuid } from '@/commons/utils/layer-utils';
import { LayerType } from '@/commons/enums/layer-type';
const STEP = {
    1: { 'tip': '指定天沟的基点', 'mode': DYMODE_MODE.POINT },
    2: { 'tip': '指定天沟的另一端点', 'mode': DYMODE_MODE.POINT },
}
export class AssignGutterControl extends BasicControl {
    id = ARCHI_CTRL_TYPE.ASSIGN_GUTTER;

    point_down: Point = new Point();
    point_move: Point = new Point();
    dymodePoint: Vector3 = new Vector3();
    capturePoint: Vector3;
    orthogonalPoint: Vector3;
    polarPoint: Vector3;

    step: number = 1;

    helpExts: ExtrudeSurfaceT[] = [];
    originPlineT: PlineT
    helpDir: Vector3 = new Vector3(0, 1, 0)

    point_1: Point = new Point();
    point_2: Point = new Point();

    context: TnEngineContext;
    extraContext: TnEngineExtraContext;

    isInit: boolean = false

    projectUuid: string = ""
    modelUuid: string = ""

    constructor(editor: ViewEditor, listeners: Listeners) {
        super()
        this.needInit = true;
        this.editor = editor;
        this.listeners = listeners;
        this.context = TnEngineContext.getInstance();
        this.extraContext = TnEngineExtraContext.getInstance();
        this.listeners.signals.needCapture.dispatch();

        editor.renderer.domElement.addEventListener('pointermove', this.onPointerMove);
        editor.renderer.domElement.addEventListener('pointerdown', this.onPointerDown);
        listeners.signals.onPointCapture.add(this.onPointCapture);
        listeners.signals.onPointOrthogonal.add(this.onPointOrthogonal);
        listeners.signals.onPointPolarTracking.add(this.onPointPolarTracking);
        listeners.signals.setInitControlData.add(this.initControl)
        listeners.signals.onDymodeChanged.add(this.onDymodeChanged);
        this.editor.clampControl.enabled = false
        // 钝化选择
        this.editor.selectControl.setEnabled(false);
        this.listeners.signals.emptySelectedEntities.dispatch();
        // 激活动态输入
        this.extraContext.dymodeContext.enabled = true;
        // 派发动态输入信息
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);

        console.log("AssignGutterControl add");
    }

    dispose(): void {
        this.editor.renderer.domElement.removeEventListener('pointermove', this.onPointerMove);
        this.editor.renderer.domElement.removeEventListener('pointerdown', this.onPointerDown);
        this.listeners.signals.onPointCapture.remove(this.onPointCapture);
        this.listeners.signals.onPointOrthogonal.remove(this.onPointOrthogonal);
        this.listeners.signals.onPointPolarTracking.remove(this.onPointPolarTracking);
        this.listeners.signals.setInitControlData.remove(this.initControl)
        this.listeners.signals.onDymodeChanged.remove(this.onDymodeChanged);
        this.listeners.signals.noNeedCapture.dispatch();
        this.editor.selectControl.setEnabled(true);
        this.extraContext.dymodeContext.enabled = false;
        this.editor.clampControl.enabled = true;
        this.editor.orthogonalControl.enabled = false;
        this.editor.polarControl.enabled = false;

        if (this.helpExts?.length > 0) {
            for (let i = 0; i < this.helpExts.length; i++) {
                let midExt = this.helpExts[i]
                let midObj = midExt?.viewObj;
                if (midObj && !!midObj.parent) {
                    midObj.parent.remove(midObj);
                }
            }
        }

        console.log("AssignGutterControl removed");
    }

    initControl = (data: any) => {
        this.originPlineT = data.originPlineT
        this.isInit = true
        this.projectUuid = data.projectUuid
        this.modelUuid = data.modelUuid
    }

    onPointPolarTracking = (point) => {
        this.polarPoint = point;
    }

    onPointOrthogonal = (point) => {
        this.orthogonalPoint = point;
    }

    onPointCapture = (point) => {
        this.capturePoint = point;
    }

    onPointerDown = (event) => {
        if (event.button === MOUSE.RIGHT || !this.isInit) {
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
            return;
        }
        if (event.button !== MOUSE.LEFT) return;
        this.point_down.set(this.extraContext.mousePosContext.x, this.extraContext.mousePosContext.y, this.extraContext.mousePosContext.z);
        if (this.capturePoint) {
            this.point_down.copy(this.capturePoint);
        } else if (this.orthogonalPoint) {
            this.point_down.copy(this.orthogonalPoint);
        } else if (this.polarPoint) {
            this.point_down.copy(this.polarPoint);
        }

        if (this.step == 1) {
            this.step_1()
        } else if (this.step == 2) {
            this.step_2()
        }
    }

    onPointerMove = () => {
        const x = this.extraContext.mousePosContext.x;
        const y = this.extraContext.mousePosContext.y;
        const z = this.extraContext.mousePosContext.z;
        this.point_move.set(x, y, z);
        if (this.capturePoint) {
            this.point_move.copy(this.capturePoint);
        } else if (this.orthogonalPoint) {
            this.point_move.copy(this.orthogonalPoint);
        } else if (this.polarPoint) {
            this.point_move.copy(this.polarPoint);
        }

        if (this.step == 2) {
            this.move_to_rotate_gutter()
        }
    }

    onDymodeChanged = (value: dymode) => {
        if (value.mode === DYMODE_MODE.POINT) {
            this.dymodePoint.set(value.x, value.y, value.z);
            this.onKeyMouseConfirm();
        }
    }

    onKeyMouseConfirm = () => {
        this.point_down.copy(this.dymodePoint);
        if (this.step == 1) {
            this.step_1()
        } else if (this.step == 2) {
            this.step_2()
        }
    }

    helpPlane: Plane = new Plane()
    step_1 = () => {
        this.point_1.copy(this.point_down)
        this.helpPlane.setFromNormalAndCoplanarPoint(new Vector3(0, 0, 1), this.point_1)
        // 将pline绕着x轴旋转90度，竖直
        this.originPlineT.rotate(new Point(0, 0, 0), new Vector3(1, 0, 0), Math.PI / 2)
        let firstPoint = this.originPlineT.pointList[0].clone()
        let dir = this.point_1.clone().sub(firstPoint).normalize()
        let dist = this.point_1.clone().sub(firstPoint).length()
        // 新建拉伸面
        for (let i = 0; i < this.originPlineT._geoCurves.length; i++) {
            let newExtFace = new ExtrudeSurfaceT([this.originPlineT._geoCurves[i].clone()], new Vector3(0, 1, 0), 0)
            newExtFace.move(dir, dist)
            this.helpExts.push(newExtFace)
            this.extraContext.sceneContext.scene.add(newExtFace.render())
        }

        this.listeners.signals.needRender.dispatch();
        this.listeners.signals.needCapture.dispatch(this.point_down);
        this.listeners.signals.orthogonal.dispatch(this.point_down);
        this.listeners.signals.polarTracking.dispatch(this.point_down);
        this.step++
        this.listeners.signals.sendToDymodeTip.dispatch(STEP[this.step].tip + ':');
        this.extraContext.dymodeContext.setMode(STEP[this.step].mode);
        this.extraContext.stmodeContext.setStmode(STEP[this.step].tip);
    }

    helpRay: StraightLine = new StraightLine()
    // 移动鼠标的时候旋转并拉伸拉伸面
    move_to_rotate_gutter = () => {
        let hdir = new Vector3()
        this.extraContext.getCurrentViewEditor().camera.getWorldDirection(hdir)
        this.helpRay.direction.copy(hdir)
        this.helpRay.origin.copy(this.point_move)
        let crossPoint = new Point()
        this.helpRay.intersectPlane(this.helpPlane, crossPoint)
        // 获取拉伸方向与拉伸长度
        let dir = crossPoint.sub(this.point_1)
        let dist = dir.length()
        if (!dir || !dist) {
            return
        }
        // 计算旋转角度
        let angle = vector3AngleTo(this.helpDir, dir.normalize(), new Vector3(0, 0, 1)) || 0
        this.helpDir.copy(dir)
        // 重新设置方向与长度
        for (let i = 0; i < this.helpExts.length; i++) {
            this.helpExts[i].rotate(this.point_1, new Vector3(0, 0, 1), angle)
            this.helpExts[i]._geoSurface.height = dist
            this.helpExts[i].updateViewGeometry()
        }
    }

    step_2 = () => {
        let hdir = new Vector3()
        this.extraContext.getCurrentViewEditor().camera.getWorldDirection(hdir)
        this.helpRay.direction.copy(hdir)
        this.helpRay.origin.copy(this.point_down)
        let crossPoint = new Point()
        this.helpRay.intersectPlane(this.helpPlane, crossPoint)
        // 获取拉伸方向与拉伸长度
        let dir = crossPoint.sub(this.point_1)
        let dist = dir.length()
        if (!dir || !dist) {
            return
        }
        // 计算旋转角度
        let angle = vector3AngleTo(this.helpDir, dir.normalize(), new Vector3(0, 0, 1)) || 0
        this.helpDir.copy(dir)
        // 重新设置方向与长度
        for (let i = 0; i < this.helpExts.length; i++) {
            this.helpExts[i].rotate(this.point_1, new Vector3(0, 0, 1), angle)
            this.helpExts[i]._geoSurface.height = dist
            this.helpExts[i].updateViewGeometry()
        }

        getSpecialPrimitiveLayerUuid(this.projectUuid, this.modelUuid, LayerType.GUTTER).then((layerUuid: string) => {
            // 确认添加
            let command = new AddPrimitivesCommand(this.helpExts.map(item => {
                item.layerUuid = layerUuid
                return (
                    item.clone()
                )
            }))
            this.editor.history.execute(command);
            this.listeners.signals.onOpeCommandControlEnd.dispatch();
        })
    }
}